// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/less/style.less
// module id = 6
// module chunks = 0